import { render, staticRenderFns, recyclableRender, components } from "./page-foot.vue?vue&type=template&id=183c5c41&name=page-foot&"
var renderjs
import script from "./page-foot.vue?vue&type=script&lang=js&"
export * from "./page-foot.vue?vue&type=script&lang=js&"
import style0 from "./page-foot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!C:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/page-foot.vue"
export default component.exports